import AccountCreateForm from "./create-account-form";

const modul = angular
    .module("AccountCreateComponets", [])

    .directive("accountCreateForm", AccountCreateForm);

export default modul.name;
